import React, { FormEvent, useState } from 'react'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { Redirect, useLocation } from 'react-router-dom'
import { useMutation } from 'react-query'

import {
  Box,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  Button as MuiButton,
  Paper,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'
import { skuit } from 'src/services/skuit'

const Button = styled<any>(MuiButton)(spacing)

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)}px;

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: ${(props) => props.theme.spacing(10)}px;
  }
`

export const ForgotPassword = () => {
  const location = useLocation()
  const [submitted, setSubmitted] = useState(false)
  const redirectUrl = new URLSearchParams(location.search).get('redirect') || '/'

  const { mutate: forgotPassword, isLoading, isError, error } = useMutation(skuit.auth.forgotPassword, {
    onSuccess: () => {
      setSubmitted(true)
    },
  })

  if (skuit.auth.isAuthed()) {
    return <Redirect to={redirectUrl} />
  }

  const submitForm = (e: FormEvent) => {
    e.preventDefault()
    const data = new FormData(e.target as HTMLFormElement)
    forgotPassword({ email: data.get('email') as string })
  }

  return (
    <Wrapper>
      <Helmet title="Sign In" />

      <Typography component="h1" variant="h4" align="center">
        Forgot Password
      </Typography>
      {submitted ? (
        <Box mt={4}>
          <Typography>
            We have sent you an email with a password reset link. Please check your inbox.
          </Typography>
        </Box>
      ) : (
        <form onSubmit={submitForm}>
          <FormControl margin="normal" required fullWidth error={isError}>
            <InputLabel htmlFor="email">Email Address</InputLabel>
            <Input id="email" name="email" autoComplete="email" autoFocus />
            {isError && <FormHelperText id="email-text">{error.message}</FormHelperText>}
          </FormControl>

          <Button
            type="submit"
            disabled={isLoading}
            fullWidth
            variant="contained"
            color="primary"
            mb={2}
          >
            Submit
          </Button>
        </form>
      )}
    </Wrapper>
  )
}
